import { render, staticRenderFns } from "./toutiao.vue?vue&type=template&id=70acb08d&scoped=true"
import script from "./toutiao.vue?vue&type=script&lang=js"
export * from "./toutiao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70acb08d",
  null
  
)

export default component.exports